import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const List = lazy(() => import('./PrListPage'));
const Detail = lazy(() => import('./PrDetailPage'));
const Form = lazy(() => import('./PrFormPage'));

const routes: RouteObject[] = [
  { path: '/purchase-requests', element: <Guard any={['pr.read']}><List /></Guard> },
  { path: '/purchase-requests/new', element: <Guard any={['pr.create']}><Form /></Guard> },
  { path: '/purchase-requests/:id', element: <Guard any={['pr.read']}><Detail /></Guard> },
  { path: '/purchase-requests/:id/edit', element: <Guard any={['pr.create']}><Form /></Guard> },
];
export default routes;
